import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';

import { ScrollingService } from '../services/scrolling.service';

/**
 * SVRS-56614: shown instead of a normal result when CAPS flags the
 * applicant's SSN as a fraud alert and/or deceased. No prequal decision,
 * offer, or lead is presented on this screen.
 */
@Component({
  selector: 'capq-verification-required',
  templateUrl: './verification-required.component.html',
  styleUrls: ['./verification-required.component.scss'],
  standalone: false,
})
export class VerificationRequiredComponent implements AfterViewInit {
  @ViewChild('topElement') topElement!: ElementRef<HTMLDivElement>;

  readonly dealerFinderUrl =
    'https://www.creditacceptance.com/car-buyers/dealer-finder';

  constructor(private readonly scrollingService: ScrollingService) {}

  ngAfterViewInit(): void {
    this.scrollingService.scrollToTop(this.topElement.nativeElement);
  }
}
